import { AdminPages } from "./admin/admin-pages.js";
import { AdminSubscriptions } from "./admin/admin-subcriptions.js";
import { Admin } from "./admin/admin.js";
import { UsersCrud } from "./admin/users/users-crud.js";
import { AI } from "./ai/ai.js";
import { DigeducaGraduandosImportApi } from "./alianzas/digeduca-graduandos-import.js";
import { Digeduca } from "./alianzas/digeduca.js";
import { EEP } from "./alianzas/eep";
import { InvoiceAPI } from "./billing/invoices.js";
import { ProductsAPI } from "./billing/products.js";
import { RecurrenteAPI } from "./billing/recurrente.js";
import { StripeAPI } from "./billing/stripe.js";
import { SubscriptionsAPI } from "./billing/subscriptions.js";
import { BlogAPI } from "./blog/Blog.js";
import { Ads } from "./campaings/ads.js";
import { Campaings } from "./campaings/campaings.js";
import { EmailActivity } from "./campaings/email_activity.js";
import { CandidatesAPI } from "./candidates/candidates";
import { Comments } from "./candidates/comments";
import { Changelog } from "./changelog/changelog.js";
import { CloudflareR2 } from "./cloudflare/ads.js";
import { Dashboard } from "./dashboard/Dashboard";
import { Events } from "./events/events";
import { FaqAPI } from "./faq/Faq.js";
import { xget, xhttp } from "./Fetchv2.js";
import { Gallery } from "./gallery/Gallery";
import { Agreements } from "./hcm/agreements.js";
import { BulkEmployees } from "./hcm/bulk-employees.js";
import { OrgCatalogs } from "./hcm/org-catalogs.js";
import { Payroll } from "./hcm/payroll.js";
import { PerformanceReviews } from "./hcm/performance-reviews.js";
import { TimeOffPolicies } from "./hcm/time-off-policies.js";
import { TimeOffRequests } from "./hcm/time-off-requests.js";
import { Attendance } from "./hcm/time-tracking.js";
import { Headhunting } from "./headhunting/headhunting";
import { InterviewsAssigned } from "./interview/interview-assigned.js";
import { InterviewsSkills } from "./interview/interview-skills.js";
import { Interviews } from "./interview/interview.js";
import { Interviewsv1 as InterviewsV1 } from "./interview/Interviewv1.js";
import { JobTest } from "./job-test/job-test.js";
import { Jobs } from "./jobs/jobs";
import { Medicalv2API } from "./medical/Medicalv2.js";
import { Messenger, Templates } from "./messenger/Messenger";
import { Notifications } from "./notifications/Notifications";
import { Pages } from "./pages/pages";
import { Poly } from "./poly/poly";
import { Polyv2API } from "./poly/Polyv2.js";
import { Position } from "./position/position.js";
import { Print } from "./print/print";
import { Profiles } from "./profiles/Profiles";
import { Psycho } from "./psyco/psycho";
import { Reports } from "./reports/Reports";
import { MGST } from "./schemas/mg.schema-types";
import { PGST } from "./schemas/pg.schema-types.js";
import { SESAPI } from "./ses/SES";
import { SESv2API } from "./ses/SESv2.js";
import { Suggestions } from "./suggestions/suggestions";
import { Tests } from "./test/Tests";
import { UsersTemp } from "./users-temp/users-temp";
import { Users } from "./users/users";
import { World } from "./world/world.js";
export const apiadmin = {
	admin: new Admin(),
	pages: new AdminPages(),
	products: new ProductsAPI(),
	subscriptions: new AdminSubscriptions(),
	invoices: new InvoiceAPI()
};
const apiv2 = {
	ai: new AI(),
	notifications: new Notifications(),
	cloudflareR2: new CloudflareR2(),
	candidates: new CandidatesAPI(),
	blog: new BlogAPI(),
	faq: new FaqAPI(),
	suggestions: new Suggestions(),
	headhunting: new Headhunting(),
	users_crud: new UsersCrud(),
	changelog: new Changelog(),
	messenger: new Messenger(),
	users_tmp: new UsersTemp(),
	template: new Templates(),
	comments: new Comments(),
	gallery: new Gallery(),
	events: new Events(),
	psycho: new Psycho(),
	users: new Users(),
	world: new World(),
	print: new Print(),
	pages: new Pages(),
	test: new Tests(),
	ses: new SESAPI(),
	sesv2: new SESv2API(),
	poly: new Poly(),
	polyv2: new Polyv2API(),
	medicalV2Api: new Medicalv2API(),

	jobs: new Jobs(),
	profiles: new Profiles(),
	reports: new Reports(),
	positions: new Position(),
	interviews: new Interviews(),
	interviewsAssigned: new InterviewsAssigned(),
	interviewsSkills: new InterviewsSkills(),
	interview: new InterviewsV1(),
	subscriptions: new SubscriptionsAPI(),
	alianzas: {
		eep: new EEP(),
		digeduca: new Digeduca(),
		graduandosImport: new DigeducaGraduandosImportApi()
	},
	dashboard: new Dashboard(),
	stripe: new StripeAPI(),
	recurrente: new RecurrenteAPI(),
	campaings: {
		campaings: new Campaings(),
		ads: new Ads(),
		email_activity: new EmailActivity()
	},
	jobTest: new JobTest(),
	hcm: {
		attendance: new Attendance(),
		agreements: new Agreements(),
		bulkEmployees: new BulkEmployees(),
		orgCatalogs: new OrgCatalogs(),
		payroll: new Payroll(),
		timeOffPolicies: new TimeOffPolicies(),
		timeOffRequests: new TimeOffRequests(),
		performanceReviews: new PerformanceReviews()
	}
};
Object.freeze(apiv2);
// @ts-ignore
window.chrome ||= {};
// @ts-ignore
window.chrome.api = { ...apiv2, xget, xhttp };
// @ts-ignore
window.chrome.MGST = MGST;
// @ts-ignore
window.chrome.PGST = PGST;
export default apiv2;
